import { action, asyncAction } from 'lib/actions';

export const openCouponFormAction = action('couponForm/OPEN');
export const closeCouponFormAction = action('couponForm/CLOSE');
export const checkCouponAction = asyncAction('couponForm/CHECK');
export const buyRtvForCouponAction = action('couponForm/BUY');
export const removeCheckedCouponAction = action('couponForm/REMOVE_CHECKED');
